module.exports = __webpack_public_path__ + "static/media/royal-crown-estates.f9582c41.pdf";